"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsFxUrlNames = exports.ErrorNames = exports.Retry = void 0;
const constants_1 = require("../../driver/teamsApp/constants");
/**
 * @author Qianhao Dong <qidon@microsoft.com>
 */
class Retry {
}
exports.Retry = Retry;
Retry.RETRY_TIMES = 6;
Retry.BACKOFF_TIME_MS = 5000;
class ErrorNames {
}
exports.ErrorNames = ErrorNames;
// System Exceptions
ErrorNames.PRECONDITION_ERROR = "PreconditionError";
ErrorNames.PROVISION_ERROR = "ProvisionError";
ErrorNames.CONFIG_UPDATING_ERROR = "ConfigUpdatingError";
ErrorNames.CONFIG_VALIDATION_ERROR = "ConfigValidationError";
ErrorNames.BOT_REGISTRATION_NOTFOUND_ERROR = "BotRegistrationNotFoundError";
ErrorNames.MSG_ENDPOINT_UPDATING_ERROR = "MessageEndpointUpdatingError";
ErrorNames.COMMAND_EXECUTION_ERROR = "CommandExecutionError";
ErrorNames.CALL_APPSTUDIO_API_ERROR = "CallAppStudioAPIError";
ErrorNames.CREATE_BOT_REGISTRATION_API_ERROR = "CreateBotRegistrationApiError";
// User Exceptions
ErrorNames.PACK_DIR_EXISTENCE_ERROR = "PackDirectoryExistenceError";
ErrorNames.ACQUIRE_BOT_FRAMEWORK_TOKEN_ERROR = "AcquireBotFrameworkTokenError";
ErrorNames.FORBIDDEN_RESULT_BOT_FRAMEWORK_ERROR = "ForbiddenResultBotFrameworkError";
ErrorNames.CONFLICT_RESULT_BOT_FRAMEWORK_ERROR = "ConflictResultBotFrameworkError";
exports.TeamsFxUrlNames = {
    [constants_1.APP_STUDIO_API_NAMES.CREATE_BOT]: "<create-bot-registration>",
    [constants_1.APP_STUDIO_API_NAMES.GET_BOT]: "<get-bot-registration>",
    [constants_1.APP_STUDIO_API_NAMES.UPDATE_BOT]: "<update-message-endpoint>",
};
//# sourceMappingURL=constants.js.map